import { Component, ChangeDetectionStrategy } from '@angular/core';

import { FooterAbstracClassComponent } from '../../shared/footer-abstrac-class.component';
import { RowHeaderComponent } from '../../shared/row-header/row-header.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-contact',
    templateUrl: './contact.component.html',
    styleUrls: ['./contact.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RowHeaderComponent, TranslatePipe],
})
export class ContactComponent extends FooterAbstracClassComponent {}
